// src/components/SEO/FAQSchema.jsx
import React from 'react';
import { Helmet } from 'react-helmet-async';

const FAQSchema = ({ questions }) => {
    if (!questions || questions.length === 0) return null;

    const faqSchema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": questions.map((q, index) => ({
            "@type": "Question",
            "name": q.question,
            "acceptedAnswer": {
                "@type": "Answer",
                "text": q.answer
            },
            "position": index + 1
        }))
    };

    return (
        <Helmet>
            <script type="application/ld+json">
                {JSON.stringify(faqSchema)}
            </script>
        </Helmet>
    );
};

export default FAQSchema;